import request from '@/utils/request'

/**
 * 获取系统配置
 */
export function getConfig() {
  return request.post('/admin/sys_config/list')
}

/**
 * 更新系统配置
 */
export function setConfig(type, name, value) {
  return request.post('/admin/sys_config/createOrUpdate', {
    type,
    name,
    value
  })
}
